const {eventDurationOptions} = require('./eventPackageSelectionsV1');

// Fill only missing choices. Stale explicit selections must remain visible for review.
export function resolveEventBookingDraft(service = {}, draft = {}) {
 const options = Array.isArray(service?.visitTypeOptions) && service.visitTypeOptions.length
  ? service.visitTypeOptions.filter(option => option && option.enabled !== false)
  : [{id:'show',price:service?.price || 0}];
 const visitType = draft.visitType || options[0]?.id || 'show';
 const option = options.find(item => item.id === visitType) || options[0];
 const hours = eventDurationOptions(service || {}, option);
 const baseHours = Math.max(0.5, Number(service?.duration || 60) / 60);
 return {
  visitType,
  visitHours: draft.visitHours == null ? (hours.includes(baseHours) ? baseHours : hours[0] ?? baseHours) : Number(draft.visitHours),
  selectedCharacterIds: Array.isArray(draft.selectedCharacterIds) ? draft.selectedCharacterIds : [],
  ...(service?.charactersMode === 'choose_primary' ? {primaryCharacterId: draft.primaryCharacterId || ''} : {}),
  selectedExtraIds: Array.isArray(draft.selectedExtraIds) ? draft.selectedExtraIds : [],
 };
}
